import {Master} from '../master/master.model';

///!!!!!!\  ORDRE IMPORTANT NE PAS MODIFIER   /!!!!!!\
export enum PropositionStatus {

    'SUBMITTED',
    'ACCEPTED',
    'REJECTED',

    'TRANSMITTED',
    'REFUSED',
    'CONFIRMED',


    'CANCELED'
}
;
export class MasterProposal {
    constructor(public id?: number,
                public schoolProposalDate?: any,
                public schoolResponseDate?: any,
                public studentProposalDate?: any,
                public studentResponseDate?: any,
                public lastModificationDate?: any,
                public status?: PropositionStatus,
                public master?: Master,
                public formationLabel?: string,
                public isSuggestedBySchool?: Boolean
    ) {
    }

    masterToMasterProposal(m: Master): MasterProposal {
        let mp: MasterProposal = new MasterProposal;
        mp.studentResponseDate = null;
        mp.studentProposalDate = null;
        mp.schoolResponseDate = null;
        mp.schoolProposalDate = null;
        mp.master = m;
        mp.formationLabel = m.masterLabel;
        if (m.specialityLabel) {
            mp.formationLabel += ' - ' + m.specialityLabel;
        }

        return mp;
    }

    hasStatus(s: PropositionStatus) {
        return s === this.status;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal.model.ts